// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/.pnpm/css-loader@3.6.0_webpack@5.105.1/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".interstitial[data-v-7a03ffac]{padding:2em}.solution[data-v-7a03ffac]{padding:2em 7em}.system-in-maintainance[data-v-7a03ffac]{font-size:160%;color:var(--general-in-maintainance-color)}", ""]);
// Exports
module.exports = exports;
